import React from 'react';
import { Box, List, ListItemButton, ListItemIcon, ListItemText, ListItem } from '@mui/material';
import { NavLink } from 'react-router-dom';

function NavBarOptions({ navList, setOpen }) {
    return (
        <Box>
            <nav>
                <List>
                    {navList.map((item) => (
                        <ListItem key={item.title}>
                            <ListItemButton
                                component={NavLink}
                                to={item.path}
                                onClick={() => setOpen(false)}
                            >
                                <ListItemText>{item.title}</ListItemText>
                            </ListItemButton>
                        </ListItem>
                    ))}
                </List>
            </nav>
        </Box>
    );
}

export default NavBarOptions;
